import { styled } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';


export const appBarStyle = {
    backgroundColor: '#ffffff',
    color: '#000000',
    boxShadow: '0px 4px 23px rgba(0, 0, 0, 0.06)',
    marginBottom:'10px',
  };
  
  export const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: '10px',
    background: '#F2F2F2',
    '&:hover': {
      backgroundColor: '#F2F2F2',
    },
    height:'51px',
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  }));
  
  export const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }));
  
  export const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      width: '100%',
      marginTop:'5px',
    },
  }))